__turbopack_context__.v({
  "station_tile__button": "StationTile-module-scss-module__1a1quW__station_tile__button",
  "station_tile__info": "StationTile-module-scss-module__1a1quW__station_tile__info",
  "station_tile__location": "StationTile-module-scss-module__1a1quW__station_tile__location",
  "station_tile__logo": "StationTile-module-scss-module__1a1quW__station_tile__logo",
});
